import { render } from "./Farmers.vue?vue&type=template&id=43830582&scoped=true"
import script from "./Farmers.vue?vue&type=script&lang=js"
export * from "./Farmers.vue?vue&type=script&lang=js"

import "./Farmers.vue?vue&type=style&index=0&id=43830582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43830582"]])

export default __exports__